export default __webpack_public_path__ + "static/touchfree-xpress-8d5f0d5e481b8e90b84ac0b49a4218f5.webp";